import React from 'react'
import {Avatar, Card, Icon, Tag} from '@therms/atalaya'
import {formatAddress, getInitials, pluralize} from '@therms/web-js'
import {
  getTHERMSImageThumbnailUrl,
  IdLabel,
  LocationGroupTags,
  RPCDocs,
} from '@therms/react-modules'
import {RiCalendarScheduleFill} from 'react-icons/ri'

interface LocationCardProps {
  active: boolean
  address?: RPCDocs.Locations.GetLocationsList.v1.Address
  appliedServicePeriods?: number
  idLabel?: string
  locationGroupIds?: string[]
  name: string
  onClick?: () => void
  primaryImageUrl?: string
}

function LocationCard({
  active,
  address,
  appliedServicePeriods,
  idLabel,
  locationGroupIds,
  name,
  onClick,
  primaryImageUrl,
}: LocationCardProps) {
  const hasLocationGroups =
    Array.isArray(locationGroupIds) && !!locationGroupIds.length
  const showAppliedCount = !!appliedServicePeriods
  const appliedTooltip = `${appliedServicePeriods} applied ${pluralize('service period', appliedServicePeriods)}`

  return (
    <Card className="cursor-pointer" onClick={onClick} space="xxs" padding="sm">
      <div className="gap-x-base gap-y-sm flex flex-wrap items-start justify-between">
        <div className="flex items-center">
          <div className="mr-sm">
            <Avatar
              url={getTHERMSImageThumbnailUrl(primaryImageUrl)}
              symbol={getInitials(name)}
              size="xl"
            />
          </div>

          <div className="flex flex-col">
            {!active && (
              <span className="text-small text-color-critical">Inactive</span>
            )}

            <IdLabel
              className="text-color-subtle text-sm font-bold"
              idLabel={idLabel}
            />
            <div className="text-color-strong">{name}</div>
            <div className="whitespace-pre-wrap font-light">
              {formatAddress(address, true) || ' '}
            </div>
          </div>
        </div>

        {(showAppliedCount || hasLocationGroups) && (
          <div className="gap-xs flex flex-wrap items-center">
            {showAppliedCount && (
              <Tag
                tooltip={appliedTooltip}
                value={
                  <span className="gap-xxs inline-flex items-center">
                    <Icon Icon={RiCalendarScheduleFill} size="xs" />
                    {appliedServicePeriods}
                  </span>
                }
                variant="info"
              />
            )}

            {hasLocationGroups && (
              <LocationGroupTags locationGroupIds={locationGroupIds} max={3} />
            )}
          </div>
        )}
      </div>
    </Card>
  )
}

export {LocationCard}
